import React from 'react';
import PropTypes from 'prop-types';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { lightBlue100 } from 'material-ui/styles/colors';

const ChargeRow = (props) => {

    const {
        title,
        option,
        label,
        error,
        message,
        loading,
        hasUnsavedChanges,
        subtitle,
        commentInput,
        inputFirst
    } = props;

    const labelTdStyle = {
        textAlign: inputFirst ? 'right' : 'center',
        width: '20%',
        paddingRight: '15px',
        paddingTop: '5px',
        paddingBottom: '5px'
    };

    const messageStyle = {
        padding: '10px',
        display: 'none'
    };

    const rowStyle = {};

    let errorDisplay = null,
        messageDisplay = null,
        optionDisplay = null,
        subtitleDisplay = null;

    if (error) {
        errorDisplay = (
            <div style={messageStyle} className="red lighten-1 white-text">{error}</div>
        );
    }

    if (hasUnsavedChanges) {
        rowStyle.backgroundColor = lightBlue100;
    }

    if (message) {
        messageDisplay = (
            <div style={messageStyle} className="teal lighten-2 white-text">{message}</div>
        );
    }

    if (subtitle) {
        subtitleDisplay = (
            <span><br />{subtitle}</span>
        );
    }

    optionDisplay = option;

    if (loading) {
        optionDisplay = (<RefreshIndicator
            size={40}
            left={10}
            top={0}
            status="loading"
            style={{
                display: 'inline-block',
                position: 'relative'
            }} />);
    }

    const titleTd = (
        <td
            style={{
                width: '50%',
                paddingTop: '5px',
                paddingBottom: '5px'
            }}>

            {title}{subtitleDisplay}{errorDisplay}{messageDisplay}</td>
    );

    if (label) {
        const labelComponent = <td style={labelTdStyle}>
            {label}
        </td>;

        const optionsComponent = <td
            style={{
                width: '20%',
                paddingTop: '5px',
                paddingBottom: '5px',
                textAlign: inputFirst ? 'left' : 'right'
            }}>
            {optionDisplay}
            {commentInput}
        </td>;

        if (inputFirst) {
            return (<tr style={rowStyle}>
                {titleTd}
                {optionsComponent}
                {labelComponent}
            </tr>);
        }

        return (
            <tr style={rowStyle}>
                {titleTd}
                {labelComponent}
                {optionsComponent}
            </tr>
        );
    }

    return (
        <tr style={rowStyle}>

            {titleTd}
            <td
                colSpan="2"
                style={{
                    width: '40%',
                    paddingTop: '5px',
                    paddingBottom: '5px'
                }}>
                {optionDisplay}
                {commentInput}

            </td>
        </tr>
    );

};

ChargeRow.propTypes = {
    title: PropTypes.string,
    option: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    error: PropTypes.string,
    message: PropTypes.string,
    loading: PropTypes.bool,
    hasUnsavedChanges: PropTypes.bool,
    subtitle: PropTypes.string,
    label: PropTypes.object,
    commentInput: PropTypes.object
};

export default ChargeRow;


// WEBPACK FOOTER //
// ./src/components/charges/ChargeRow.js